import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import SeoHead from '../components/SeoHead';
import { localizedPath } from '../config/seo';
import './TresImmo.css';

const WaldrandPage = () => {
  const { lang, setLang } = useLanguage();

  const content = {
    de: {
      title: 'Am Waldrand', subtitle: 'Wohnbauprojekt in Oberbozen am Ritten', backLink: 'Zurück zur Startseite',
      sections: [
        { title: 'Das Gebäude', text: 'Das Wohnbauprojekt „Am Waldrand" umfasst 11 exklusive Wohneinheiten, verteilt auf vier Geschosse. Die Architektur verbindet alpine Tradition mit zeitgenössischem Design. Natürliche Materialien wie Holz, Stein und Glas fügen sich harmonisch in die umgebende Berglandschaft ein.' },
        { title: 'Standort & Umgebung', text: 'Oberbozen am Ritten, auf 1.200 Metern über dem Meeresspiegel gelegen, bietet das Beste aus zwei Welten: alpines Naturerlebnis und städtische Erreichbarkeit. Die Seilbahn verbindet Oberbozen in nur 12 Minuten mit der Altstadt von Bozen. Wanderwege, Skigebiete und das historische Rittner Bahnl sind in unmittelbarer Nähe.' },
        { title: 'Ausstattung & Qualität', text: 'Alle Wohnungen erfüllen den KlimaHaus-Standard und vereinen höchste Energieeffizienz mit nachhaltigem Wohnkomfort. Bodentiefe Fensterfronten, großzügige Terrassen und Eigengärten schaffen fließende Übergänge zwischen Innen- und Außenraum. Die Tiefgarage bietet geschützte Stellplätze für alle Einheiten.' },
        { title: 'Wohnungstypen', items: ['2-Zimmer-Wohnungen (ca. 65–87 m²) – ideal als Ferienwohnung oder Kapitalanlage', '3-Zimmer-Wohnungen (ca. 79–108 m²) – perfekt für Paare und kleine Familien', '4-Zimmer-Penthouse (ca. 122–123 m²) – exklusives Wohnen auf höchstem Niveau'] },
        { title: 'Investition & Nutzung', text: 'Alle Einheiten sind frei von Bindungen und können uneingeschränkt als Ferienwohnung genutzt werden. Die Kombination aus exklusiver Lage, hochwertiger Bauweise und touristischer Attraktivität macht „Am Waldrand" zu einer soliden Wertanlage.' },
      ],
    },
    it: {
      title: 'Ai Margini del Bosco', subtitle: 'Progetto residenziale a Soprabolzano sul Renon', backLink: 'Torna alla pagina principale',
      sections: [
        { title: "L'Edificio", text: 'Il progetto "Ai Margini del Bosco" comprende 11 unità abitative esclusive distribuite su quattro piani. L\'architettura combina tradizione alpina con design contemporaneo.' },
        { title: 'Posizione & Dintorni', text: 'Soprabolzano sul Renon, a 1.200 metri sul livello del mare, offre il meglio di due mondi: natura alpina e raggiungibilità urbana.' },
        { title: 'Dotazioni & Qualità', text: 'Tutti gli appartamenti soddisfano lo standard KlimaHaus e combinano massima efficienza energetica con comfort abitativo sostenibile.' },
        { title: 'Tipologie', items: ['Bilocali (ca. 65–87 m²)', 'Trilocali (ca. 79–108 m²)', 'Penthouse 4 locali (ca. 122–123 m²)'] },
        { title: 'Investimento', text: 'Tutte le unità sono libere da vincoli e possono essere utilizzate senza restrizioni come case vacanza.' },
      ],
    },
    en: {
      title: "At the Forest's Edge", subtitle: 'Residential project in Oberbozen on the Ritten', backLink: 'Back to homepage',
      sections: [
        { title: 'The Building', text: 'The "At the Forest\'s Edge" project comprises 11 exclusive residential units across four floors, blending alpine tradition with contemporary design.' },
        { title: 'Location & Surroundings', text: 'Oberbozen on the Ritten, at 1,200 metres above sea level, offers the best of both worlds: alpine nature and urban accessibility. The cable car connects to Bolzano in just 12 minutes.' },
        { title: 'Amenities & Quality', text: 'All apartments meet the KlimaHaus standard, combining maximum energy efficiency with sustainable living comfort.' },
        { title: 'Apartment Types', items: ['2-room apartments (ca. 65–87 m²)', '3-room apartments (ca. 79–108 m²)', '4-room penthouse (ca. 122–123 m²)'] },
        { title: 'Investment', text: 'All units are free from restrictions and can be used without limitation as holiday residences.' },
      ],
    },
  };

  const c = content[lang] || content.de;

  return (
    <>
    <SeoHead page="waldrand" />
    <div className="tres-page">
      <div className="bg-fixed" /><div className="ring" /><div className="ring" /><div className="ring" />
      <nav className="topnav">
        <a href={localizedPath(lang, '/')} className="topnav-logo" style={{ textDecoration: 'none' }}>TRES IMMO</a>
        <div />
        <div className="topnav-right">
          <div className="lang-switcher">
            {['de','it','en'].map((l, i) => (
              <React.Fragment key={l}>
                {i > 0 && <span>·</span>}
                <button className={lang === l ? 'active' : ''} onClick={() => setLang(l)}>{l.toUpperCase()}</button>
              </React.Fragment>
            ))}
          </div>
        </div>
      </nav>
      <section style={{ padding: 'clamp(6rem,12vw,10rem) clamp(1.5rem,6vw,5rem) 4rem', maxWidth: 900, margin: '0 auto', position: 'relative', zIndex: 2 }}>
        <a href={localizedPath(lang, '/')} style={{ fontSize: '0.65rem', letterSpacing: '0.3em', textTransform: 'uppercase', color: 'var(--gold)', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '0.4rem', marginBottom: '2rem' }}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="15 18 9 12 15 6"/></svg>
          {c.backLink}
        </a>
        <p className="section-label visible">{c.subtitle}</p>
        <h1 className="projekt-headline visible" style={{ marginBottom: '3rem' }}><em>{c.title}</em></h1>
        {c.sections.map((sec, i) => (
          <div key={i} style={{ marginBottom: '2.5rem', borderTop: i > 0 ? '1px solid rgba(184,154,94,0.1)' : 'none', paddingTop: i > 0 ? '2.5rem' : 0 }}>
            <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 'clamp(1.3rem,4vw,2rem)', fontWeight: 300, color: 'var(--gold)', marginBottom: '1rem' }}>{sec.title}</h2>
            {sec.text && <p style={{ fontSize: '0.92rem', lineHeight: 1.8, color: 'var(--muted)', fontWeight: 200 }}>{sec.text}</p>}
            {sec.items && (
              <ul style={{ listStyle: 'none', padding: 0, display: 'flex', flexDirection: 'column', gap: '0.6rem', marginTop: '0.5rem' }}>
                {sec.items.map((item, j) => (
                  <li key={j} style={{ fontSize: '0.9rem', color: 'var(--muted)', fontWeight: 200, paddingLeft: '1.2rem', position: 'relative' }}>
                    <span style={{ position: 'absolute', left: 0, color: 'var(--gold)' }}>·</span>{item}
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
        <div style={{ marginTop: '3rem', paddingTop: '2rem', borderTop: '1px solid rgba(184,154,94,0.1)' }}>
          <iframe
            title="Standort Am Waldrand Oberbozen"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2746.5!2d11.4458!3d46.5314!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDbCsDMxJzUzLjAiTiAxMcKwMjYnNDQuOSJF!5e0!3m2!1sde!2sit!4v1"
            width="100%" height="300" style={{ border: '1px solid rgba(184,154,94,0.2)', borderRadius: 4, filter: 'saturate(0.3) brightness(0.85)', transition: 'filter 0.4s' }}
            allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade"
            onMouseEnter={e => e.target.style.filter = 'saturate(0.6) brightness(0.95)'}
            onMouseLeave={e => e.target.style.filter = 'saturate(0.3) brightness(0.85)'}
          />
        </div>
        <div style={{ marginTop: '2rem', display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
          <a className="wa-btn visible" href={`${localizedPath(lang, '/')}#einheiten`} style={{ textDecoration: 'none' }}>
            <span>{lang === 'de' ? 'Zu den Einheiten' : lang === 'it' ? 'Alle unità' : 'View units'}</span>
          </a>
          <a className="wa-btn visible" href="https://wa.me/393935652804" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
            <span>WhatsApp</span>
          </a>
        </div>
      </section>
      <footer className="tres-footer">
        <div className="footer-bottom">© {new Date().getFullYear()} TRES IMMO · Oberbozen, Ritten, Südtirol</div>
      </footer>
    </div>
    </>
  );
};

export default WaldrandPage;
